import { useSyncExternalStore } from "react";

let isOpen = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return isOpen;
}

function toggle() {
  isOpen = !isOpen;
  for (const listener of listeners) listener();
}

function close() {
  if (!isOpen) return;
  isOpen = false;
  for (const listener of listeners) listener();
}

// No editable-target guard, so it toggles while the chat input is focused; match
// on e.code because Shift turns the "." key's e.key into ">".
document.addEventListener("keydown", (e: KeyboardEvent) => {
  if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.code === "Period") {
    e.preventDefault();
    toggle();
  }
});

export function useComposerStrip() {
  const open = useSyncExternalStore(subscribe, getSnapshot);
  return { open, toggle, close };
}
